// extracted by mini-css-extract-plugin
export var text = "_94-0";